import { demoData } from './data';

const ok = (msg?: string) => ({ success: true, message: msg ?? 'Demo mode' });

export const demoPayrollService = {
  // ========== Parental Leave ==========
  getParentalLeaveSummary: async () => ({
    total_records: 4,
    active_count: 1,
    planned_count: 1,
    completed_count: 2,
    cancelled_count: 0,
    by_type: { '출산휴가': 1, '배우자출산휴가': 1, '육아휴직': 1, '육아기근로시간단축': 1 },
    by_status: { '사용중': 1, '예정': 1, '완료': 2 },
  }),
  getParentalLeaveAlerts: async () => [
    {
      id: 2, employee_id: 'TS2600019', employee_name: '한소영',
      leave_type: 'parental', leave_type_label: '육아휴직',
      end_date: new Date(Date.now() + 18 * 86400000).toISOString().slice(0, 10),
      days_until_return: 18, alert_level: 'medium',
      message: '한소영 육아휴직 복귀 18일 전',
    },
  ],
  getParentalLeaveRecords: async () => [
    {
      id: 1, employee_id: 'TS2600008', employee_name: '김지현',
      leave_type: 'maternity', leave_type_label: '출산휴가',
      start_date: '2025-06-01', end_date: '2025-08-29', status: 'completed', status_label: '완료',
      child_birth_date: '2025-06-15', child_name: '김서윤', notes: '정상 출산',
      created_at: Date.now() / 1000 - 200 * 86400,
    },
    {
      id: 2, employee_id: 'TS2600019', employee_name: '한소영',
      leave_type: 'parental', leave_type_label: '육아휴직',
      start_date: '2025-09-01', end_date: new Date(Date.now() + 18 * 86400000).toISOString().slice(0, 10),
      status: 'active', status_label: '사용중',
      child_birth_date: '2025-05-20', child_name: '한지우', notes: null,
      created_at: Date.now() / 1000 - 150 * 86400,
    },
    {
      id: 3, employee_id: 'TS2600015', employee_name: '정대현',
      leave_type: 'paternity', leave_type_label: '배우자출산휴가',
      start_date: '2025-10-01', end_date: '2025-10-10', status: 'completed', status_label: '완료',
      child_birth_date: '2025-09-28', child_name: '정하율', notes: null,
      created_at: Date.now() / 1000 - 100 * 86400,
    },
    {
      id: 4, employee_id: 'TS2600008', employee_name: '김지현',
      leave_type: 'childcare_reduction', leave_type_label: '육아기근로시간단축',
      start_date: '2026-03-01', end_date: '2026-08-31', status: 'planned', status_label: '예정',
      child_birth_date: '2025-06-15', child_name: '김서윤', notes: '주 25시간 근무',
      created_at: Date.now() / 1000 - 10 * 86400,
    },
  ],
  getEmployeeParentalLeave: async (id: string) => id === 'TS2600015' ? [
    { id: 1, employee_id: 'TS2600015', leave_type: 'maternity', start_date: '2025-09-01', end_date: '2025-11-30', status: 'completed', child_birth_date: '2025-09-15' },
  ] : [],
  createParentalLeave: async () => ok('Parental leave created (demo)'),
  updateParentalLeave: async () => ok('Parental leave updated (demo)'),

  // ========== Access Logs ==========
  getAccessLogSummary: async () => ({
    today_count: 5,
    week_count: 18,
    month_count: 47,
    total_count: 312,
    unique_users: 4,
    top_users: [
      { username: 'admin', count: 22 },
      { username: 'hr_manager', count: 15 },
      { username: 'team_leader_kim', count: 7 },
      { username: 'team_leader_park', count: 3 },
    ],
    by_resource_type: { '직원 상세정보': 28, '급여 정보': 9, '평가 결과': 6, '근로계약 정보': 4 },
    by_action: { '조회': 39, '수정': 5, '다운로드/내보내기': 3 },
    retention_days: 180,
    oldest_log_date: '2025-08-15',
  }),
  getAccessLogAlerts: async () => [
    {
      type: 'sensitive_action',
      level: 'medium',
      message: 'admin이(가) 오늘 다운로드/내보내기 2건을 수행했습니다',
      username: 'admin',
      action: 'export',
      count: 2,
      detected_at: new Date().toISOString().slice(0, 16).replace('T', ' '),
    },
  ],
  getAccessLogs: async () => ({
    logs: [
      { id: 1, username: 'admin', action: 'view', action_label: '조회', resource_type: 'employee_detail', resource_type_label: '직원 상세정보', resource_id: 'TS2600001', ip_address: '192.168.1.10', created_at: Date.now() / 1000 - 300, created_at_formatted: new Date(Date.now() - 300000).toLocaleString('ko-KR') },
      { id: 2, username: 'hr_manager', action: 'view', action_label: '조회', resource_type: 'salary_info', resource_type_label: '급여 정보', resource_id: 'TS2600005', ip_address: '192.168.1.20', created_at: Date.now() / 1000 - 1200, created_at_formatted: new Date(Date.now() - 1200000).toLocaleString('ko-KR') },
      { id: 3, username: 'admin', action: 'export', action_label: '다운로드/내보내기', resource_type: 'employee_detail', resource_type_label: '직원 상세정보', resource_id: 'TS2600010', ip_address: '192.168.1.10', created_at: Date.now() / 1000 - 3600, created_at_formatted: new Date(Date.now() - 3600000).toLocaleString('ko-KR') },
      { id: 4, username: 'team_leader_kim', action: 'view', action_label: '조회', resource_type: 'evaluation_result', resource_type_label: '평가 결과', resource_id: 'TS2600003', ip_address: '192.168.1.30', created_at: Date.now() / 1000 - 7200, created_at_formatted: new Date(Date.now() - 7200000).toLocaleString('ko-KR') },
      { id: 5, username: 'admin', action: 'edit', action_label: '수정', resource_type: 'personnel_record', resource_type_label: '인사기록', resource_id: 'TS2600012', ip_address: '192.168.1.10', created_at: Date.now() / 1000 - 14400, created_at_formatted: new Date(Date.now() - 14400000).toLocaleString('ko-KR') },
      { id: 6, username: 'hr_manager', action: 'view', action_label: '조회', resource_type: 'contract_info', resource_type_label: '근로계약 정보', resource_id: 'TS2600020', ip_address: '192.168.1.20', created_at: Date.now() / 1000 - 28800, created_at_formatted: new Date(Date.now() - 28800000).toLocaleString('ko-KR') },
      { id: 7, username: 'admin', action: 'view', action_label: '조회', resource_type: 'training_record', resource_type_label: '교육 이력', resource_id: 'TS2600007', ip_address: '192.168.1.10', created_at: Date.now() / 1000 - 43200, created_at_formatted: new Date(Date.now() - 43200000).toLocaleString('ko-KR') },
      { id: 8, username: 'hr_manager', action: 'view', action_label: '조회', resource_type: 'employee_detail', resource_type_label: '직원 상세정보', resource_id: 'TS2600015', ip_address: '192.168.1.20', created_at: Date.now() / 1000 - 86400, created_at_formatted: new Date(Date.now() - 86400000).toLocaleString('ko-KR') },
      { id: 9, username: 'admin', action: 'export', action_label: '다운로드/내보내기', resource_type: 'salary_info', resource_type_label: '급여 정보', resource_id: 'ALL', ip_address: '192.168.1.10', created_at: Date.now() / 1000 - 172800, created_at_formatted: new Date(Date.now() - 172800000).toLocaleString('ko-KR') },
      { id: 10, username: 'team_leader_park', action: 'view', action_label: '조회', resource_type: 'evaluation_result', resource_type_label: '평가 결과', resource_id: 'TS2600025', ip_address: '192.168.1.35', created_at: Date.now() / 1000 - 259200, created_at_formatted: new Date(Date.now() - 259200000).toLocaleString('ko-KR') },
    ],
    total: 312,
  }),
  purgeAccessLogs: async () => ok('Access logs purged (demo)'),

  // ========== Audit Logs ==========
  getAuditSummary: async () => ({
    today_count: 45, week_count: 234, month_count: 891, total_count: 4523,
    unique_users: 8, login_failures_today: 1,
    by_action: { '로그인': 320, '조회': 210, '수정': 85, '다운로드': 42, '생성': 31, '삭제': 5 },
    by_resource_type: { '직원': 310, '인사평가': 89, '리포트': 42, '시스템': 320, '조직': 25 },
    top_users: [
      { username: 'user1', count: 156 },
      { username: 'user2', count: 132 },
      { username: 'kyungsoo.kim', count: 98 },
    ],
  }),
  getAuditLogs: async () => ({
    logs: [
      { id: 1, username: 'user1', action: 'login', action_label: '로그인', resource_type: 'system', resource_type_label: '시스템', resource_id: null, details: null, old_value: null, new_value: null, ip_address: '10.0.1.5', created_at: Date.now()/1000, created_at_formatted: '2026-02-10 09:05:12' },
      { id: 2, username: 'user2', action: 'read', action_label: '조회', resource_type: 'employee', resource_type_label: '직원', resource_id: 'TS2600003', details: null, old_value: null, new_value: null, ip_address: '10.0.1.8', created_at: Date.now()/1000 - 600, created_at_formatted: '2026-02-10 08:55:03' },
      { id: 3, username: 'user1', action: 'export', action_label: '다운로드', resource_type: 'report', resource_type_label: '리포트', resource_id: 'employee_roster', details: '리포트 다운로드 (excel)', old_value: null, new_value: null, ip_address: '10.0.1.5', created_at: Date.now()/1000 - 1200, created_at_formatted: '2026-02-10 08:45:21' },
    ],
    total: 3,
  }),
  getAuditTrail: async () => [
    { id: 1, action: 'read', resource_type: 'employee', resource_id: 'TS2600001', username: 'user1@example.com', timestamp: '2026-02-14T10:30:00', details: '직원 상세 조회' },
    { id: 2, action: 'update', resource_type: 'employee', resource_id: 'TS2600005', username: 'user2@example.com', timestamp: '2026-02-14T09:15:00', details: '직급 변경' },
    { id: 3, action: 'export', resource_type: 'report', resource_id: 'team_headcount', username: 'user1@example.com', timestamp: '2026-02-13T16:00:00', details: '팀별 인원 현황 리포트 다운로드' },
  ],
  getAuditLabels: async () => ({
    actions: { login: '로그인', read: '조회', update: '수정', create: '생성', delete: '삭제', export: '다운로드' },
    resource_types: { employee: '직원', evaluation: '인사평가', report: '리포트', system: '시스템' },
  }),

  // ========== Transfer Consent ==========
  getTransferConsentSummary: async () => ({
    total_records: 3, pending_count: 1, agreed_count: 2, refused_count: 0, withdrawn_count: 0,
    by_type: { '전보': 1, '직무변경': 1, '파견': 1 },
    by_status: { '대기중': 1, '동의': 2 },
  }),
  getTransferConsentRecords: async () => [
    { id: 1, employee_id: 'TS2600003', employee_name: '이영수', transfer_type: 'transfer', transfer_type_label: '전보', from_value: '영업팀', to_value: '연구개발팀', reason: '프로젝트 수요 증가에 따른 인력 재배치', consent_status: 'agreed', consent_status_label: '동의', consent_date: '2026-01-15', effective_date: '2026-02-01', notes: '본인 희망 전보', created_at: Date.now() / 1000 - 30 * 86400 },
    { id: 2, employee_id: 'TS2600012', employee_name: '오세진', transfer_type: 'role_change', transfer_type_label: '직무변경', from_value: '품질검사 담당', to_value: '품질관리 책임자', reason: '직무 역량 강화 및 승진 연계', consent_status: 'pending', consent_status_label: '대기중', consent_date: null, effective_date: '2026-03-01', notes: null, created_at: Date.now() / 1000 - 5 * 86400 },
    { id: 3, employee_id: 'TS2600021', employee_name: '안수빈', transfer_type: 'secondment', transfer_type_label: '파견', from_value: '품질관리팀', to_value: '협력사 A (6개월)', reason: '품질 관리 기술 이전', consent_status: 'agreed', consent_status_label: '동의', consent_date: '2025-12-20', effective_date: '2026-01-10', notes: '파견 수당 별도 지급', created_at: Date.now() / 1000 - 50 * 86400 },
  ],
  createTransferConsent: async () => ok('Transfer consent created (demo)'),
  updateTransferConsent: async () => ok('Transfer consent updated (demo)'),

  // ========== Personnel Changes ==========
  getAllPersonnelChanges: async (_limit?: number, _changeType?: string, _orgUnitId?: number) => demoData.personnelChanges ?? { changes: [], total: 0 },
  addPersonnelChange: async () => ({ message: 'Demo mode', change_id: 0, employee_id: '' }),
  deletePersonnelChange: async () => ({ message: 'Demo mode', deleted_id: 0 }),

  // ========== Employee Photo ==========
  uploadEmployeePhoto: async () => ok('Photo uploaded (demo)'),
  getEmployeePhotoUrl: (_employeeId: string) => '',
  deleteEmployeePhoto: async () => ok('Photo deleted (demo)'),

  // ========== Employee Status ==========
  getEmployeeStatus: async (id: string) => ({ employee_id: id, status: 'active', updated_at: '2026-01-01' }),
  updateEmployeeStatus: async () => ({ message: 'Demo mode', employee_id: '', status: '' }),
  getAllEmployeeStatuses: async () => ({
    statuses: demoData.employees?.employees?.map((e: any) => ({ employee_id: e.employee_id, name: e.name, status: e.status || 'active', address: e.region })) || [],
    total: demoData.employees?.total || 0,
  }),
  getEmployeesByStatus: async (status: string) => {
    const emps = demoData.employees?.employees?.filter((e: any) => (e.status || 'active') === status) || [];
    return { status, employees: emps, total: emps.length };
  },

  // ========== Annual Leave ==========
  getAnnualLeaveAlerts: async () => demoData.annualLeaveAlerts ?? { expiring_soon: [], low_usage: [], total_alerts: 0 },
  getAnnualLeaveSummary: async () => demoData.annualLeaveSummary ?? {
    employee_count: 0, total_granted: 0, total_used: 0, total_remaining: 0, avg_usage_rate: 0, details: [],
  },
  getEmployeeAnnualLeave: async (id: string) => {
    const detail = demoData.annualLeaveSummary?.details?.find((d: any) => d.employee_id === id);
    const balance = detail
      ? { year: 2026, granted: detail.granted, used: detail.used, remaining: detail.remaining, years_of_service: 3, hire_date: '2023-03-01', expiry_date: '2027-12-31' }
      : { year: 2026, granted: 15, used: 0, remaining: 15, years_of_service: 3, hire_date: '2023-03-01', expiry_date: '2027-12-31' };
    return { employee_id: id, is_executive: false, balance, history: [] };
  },
  useAnnualLeave: async () => ok('Leave recorded (demo)'),
  generateAnnualLeaves: async () => ({ generated: 30, skipped: 2, errors: 0, excluded_executives: 3, details: [] }),
  grantAnnualLeave: async () => ({ id: 1, employee_id: 'demo', year: 2026, granted: 15, basis: '근속 3년 (기본 15일)', expiry_date: '2027-12-31' }),

  // ========== Overtime ==========
  getOvertimeRealtimeWarnings: async () => ({ week_start: '2026-02-09', days_remaining_in_week: 3, threshold_hours: 48, total_warnings: 0, critical_violations: { count: 0, legal_warning: null, items: [] }, approaching_limit: { count: 0, action: '', items: [] } }),
  getOvertimeRisks: async () => demoData.overtimeRisks ?? { risks: [], total: 0 },
  getOvertimeStats: async () => demoData.overtimeStats ?? { week_start: '', total_employees: 0, avg_hours: 0, details: [] },
  recordAttendance: async () => ok('Attendance recorded (demo)'),

  // ========== Severance ==========
  getSeveranceAlerts: async () => demoData.severanceAlerts ?? { approaching: [], unpaid: [], total_alerts: 0 },
  getAllSeverances: async () => demoData.severances ?? { severances: [], total: 0 },
  calculateSeverance: async () => ({ employee_id: '', amount: 0, details: {} }),

  // ========== Training ==========
  getTrainingAlerts: async () => demoData.trainingAlerts ?? { overdue: [], upcoming: [], total_alerts: 0 },
  getTrainingSummary: async () => demoData.trainingSummary ?? { total_courses: 0, total_records: 0, compliance_rate: 0, details: [] },
  getTrainingCourses: async (category?: string) => {
    const data = demoData.trainingCourses ?? { courses: [], total: 0 };
    if (category === 'mandatory') {
      const mandatory = data.courses.filter((c: any) => c.is_mandatory);
      return { courses: mandatory, total: mandatory.length };
    }
    return data;
  },
  getEmployeeTraining: async (id: string) => ({
    employee_id: id,
    records: [
      { id: 1, course_name: '성희롱 예방 교육', completed_date: '2026-01-10', status: 'completed' },
      { id: 2, course_name: '개인정보보호 교육', completed_date: '2026-01-12', status: 'completed' },
      { id: 3, course_name: '퇴직연금 교육', completed_date: '2025-12-20', status: 'completed' },
    ],
    total: 3,
  }),
  getTeamTraining: async (team: string) => {
    const emps = demoData.employees?.employees?.filter((e: any) => e.team === team) || [];
    return {
      team,
      records: emps.map((e: any) => ({ employee_id: e.employee_id, employee_name: e.name, completed: 4, total: 6, compliance_rate: 66.7 })),
      total: emps.length,
    };
  },
  createTrainingCourse: async () => ok('Training course created (demo)'),
  recordTraining: async () => ok('Training recorded (demo)'),
  getNonCompliantEmployees: async () => ({
    items: [
      { employee_id: 'TS2600007', employee_name: '윤성민', team: '영업팀', course_name: '개인정보보호 교육' },
      { employee_id: 'TS2600007', employee_name: '윤성민', team: '영업팀', course_name: '장애인 인식개선 교육' },
      { employee_id: 'TS2600008', employee_name: '한지수', team: '영업팀', course_name: '성희롱 예방 교육' },
      { employee_id: 'TS2600008', employee_name: '한지수', team: '영업팀', course_name: '산업안전보건 교육' },
      { employee_id: 'TS2600023', employee_name: '구본석', team: '생산팀', course_name: '산업안전보건 교육' },
      { employee_id: 'TS2600023', employee_name: '구본석', team: '생산팀', course_name: '장애인 인식개선 교육' },
      { employee_id: 'TS2600023', employee_name: '구본석', team: '생산팀', course_name: '직장 내 괴롭힘 예방' },
      { employee_id: 'TS2600029', employee_name: '백도윤', team: 'IT개발팀', course_name: '성희롱 예방 교육' },
      { employee_id: 'TS2600029', employee_name: '백도윤', team: 'IT개발팀', course_name: '개인정보보호 교육' },
      { employee_id: 'TS2600029', employee_name: '백도윤', team: 'IT개발팀', course_name: '산업안전보건 교육' },
      { employee_id: 'TS2600029', employee_name: '백도윤', team: 'IT개발팀', course_name: '장애인 인식개선 교육' },
    ],
    total: 11,
  }),

  // ========== Safety & Health ==========
  getSafetyEducationSummary: async () => ({
    year: '2026', total_employees: 29, completed_employees: 24, not_completed: 5,
    completion_rate: 82.8, total_records: 38,
    by_type: { regular: 24, hiring: 5, change: 3, special: 6 },
  }),
  getSafetyEducations: async () => ({
    records: [
      { id: 1, employee_id: 'TS2600001', employee_name: '김영수', team: '경영지원팀', education_type: 'regular', education_name: '1분기 정기 안전보건교육', education_date: '2026-01-15', education_hours: 6, provider: '한국산업안전보건공단', is_completed: true, notes: null },
      { id: 2, employee_id: 'TS2600009', employee_name: '이승민', team: '영업팀', education_type: 'regular', education_name: '1분기 정기 안전보건교육', education_date: '2026-01-15', education_hours: 6, provider: '한국산업안전보건공단', is_completed: true, notes: null },
      { id: 3, employee_id: 'TS2600029', employee_name: '신입사원', team: 'IT개발팀', education_type: 'hiring', education_name: '채용 시 안전보건교육', education_date: '2026-01-20', education_hours: 8, provider: '사내 안전관리자', is_completed: true, notes: '신규입사자' },
      { id: 4, employee_id: 'TS2600015', employee_name: '최현석', team: '생산팀', education_type: 'change', education_name: '작업변경 교육 (라인 이동)', education_date: '2026-01-25', education_hours: 2, provider: '사내 안전관리자', is_completed: true, notes: '생산라인 변경' },
      { id: 5, employee_id: 'TS2600016', employee_name: '윤지영', team: '생산팀', education_type: 'special', education_name: '밀폐공간 작업 특별교육', education_date: '2026-02-01', education_hours: 16, provider: '안전교육센터', is_completed: true, notes: '밀폐공간 출입 자격' },
    ],
    total: 5,
  }),
  createSafetyEducation: async () => ({ id: 6, employee_id: 'NEW' }),
  getHealthCheckupSummary: async () => ({
    year: '2026', total_employees: 29, checked_employees: 26, not_checked: 3,
    checkup_rate: 89.7, abnormal_count: 2,
    by_result: { normal: 20, observe: 4, caution: 1, abnormal: 1 },
    by_type: { general: 23, special: 3 },
  }),
  getHealthCheckups: async () => ({
    records: [
      { id: 1, employee_id: 'TS2600001', employee_name: '김영수', team: '경영지원팀', checkup_type: 'general', checkup_date: '2026-01-10', next_due_date: '2027-01-10', result: 'normal', institution: '삼성서울병원', notes: null },
      { id: 2, employee_id: 'TS2600015', employee_name: '최현석', team: '생산팀', checkup_type: 'special', checkup_date: '2025-12-05', next_due_date: '2026-06-05', result: 'observe', institution: '직업환경의학센터', notes: '소음성 난청 관찰' },
      { id: 3, employee_id: 'TS2600003', employee_name: '이민호', team: '연구개발팀', checkup_type: 'general', checkup_date: '2026-01-10', next_due_date: '2027-01-10', result: 'caution', institution: '삼성서울병원', notes: '고혈압 주의' },
      { id: 4, employee_id: 'TS2600020', employee_name: '박지현', team: '품질관리팀', checkup_type: 'general', checkup_date: '2026-01-10', next_due_date: '2027-01-10', result: 'normal', institution: '삼성서울병원', notes: null },
    ],
    total: 4,
  }),
  createHealthCheckup: async () => ({ id: 5, employee_id: 'NEW' }),
  getSafetyHealthAlerts: async () => ({
    alerts: [
      { type: 'education_overdue', severity: 'warning', employee_id: 'TS2600007', employee_name: '정수빈', message: '정수빈님의 정기 안전보건교육 미이수 (1분기)' },
      { type: 'checkup_overdue', severity: 'warning', employee_id: 'TS2600023', employee_name: '김태호', message: '김태호님의 일반건강진단 기한 초과 (만료일: 2025-12-31)' },
    ],
    total: 2,
  }),

  // ========== Headcount & Recruitment ==========
  getHeadcountSummary: async () => ({
    year: 2026, total_planned: 30, total_current: 29, total_vacancy: 1, fill_rate: 96.7,
    departments: [
      { department: '경영지원팀', planned_count: 5, current_count: 5, vacancy: 0, surplus: 0 },
      { department: '영업팀', planned_count: 6, current_count: 6, vacancy: 0, surplus: 0 },
      { department: '연구개발팀', planned_count: 5, current_count: 5, vacancy: 0, surplus: 0 },
      { department: '품질관리팀', planned_count: 4, current_count: 4, vacancy: 0, surplus: 0 },
      { department: '생산팀', planned_count: 5, current_count: 5, vacancy: 0, surplus: 0 },
      { department: 'IT개발팀', planned_count: 5, current_count: 4, vacancy: 1, surplus: 0 },
    ],
  }),
  getHeadcountPlans: async () => ({
    plans: [
      { id: 1, department: '경영지원팀', year: 2026, planned_count: 5, notes: null },
      { id: 2, department: '영업팀', year: 2026, planned_count: 6, notes: null },
      { id: 3, department: '연구개발팀', year: 2026, planned_count: 5, notes: null },
      { id: 4, department: '품질관리팀', year: 2026, planned_count: 4, notes: null },
      { id: 5, department: '생산팀', year: 2026, planned_count: 5, notes: null },
      { id: 6, department: 'IT개발팀', year: 2026, planned_count: 5, notes: '시니어 1명 증원 예정' },
    ],
    total: 6,
  }),
  setHeadcountPlan: async () => ({ id: 1, department: 'IT개발팀', year: 2026, planned_count: 5 }),
  getRecruitments: async () => ({
    records: [
      { id: 1, department: 'IT개발팀', position_title: '시니어 백엔드 개발자', rank: '과장', headcount: 1, status: 'screening', reason: 'expansion', requester: '김영수', request_date: '2026-01-15', target_date: '2026-03-31', notes: 'Python/FastAPI 경력 5년+', created_at: 1705276800 },
      { id: 2, department: '영업팀', position_title: '영업 담당자', rank: '주임', headcount: 1, status: 'interviewing', reason: 'replacement', requester: '이승민', request_date: '2026-01-20', target_date: '2026-03-15', notes: '전임자 퇴직 대체', created_at: 1705363200 },
      { id: 3, department: '생산팀', position_title: '생산직 사원', rank: '사원', headcount: 2, status: 'open', reason: 'expansion', requester: '최현석', request_date: '2026-02-01', target_date: '2026-04-30', notes: '라인 증설 인력', created_at: 1706745600 },
    ],
    total: 3,
  }),
  createRecruitment: async () => ({ id: 4, department: 'NEW', position_title: 'NEW' }),
  updateRecruitment: async () => ({ id: 1, updated: true }),
  getRecruitmentSummary: async () => ({
    total: 3, active: 3,
    by_status: { open: { count: 1, headcount: 2 }, screening: { count: 1, headcount: 1 }, interviewing: { count: 1, headcount: 1 } },
  }),

  // ========== Skill Matrix ==========
  getSkillCategories: async () => [
    { id: 1, name: '프로그래밍 언어', sort_order: 1 },
    { id: 2, name: '프레임워크/라이브러리', sort_order: 2 },
    { id: 3, name: '클라우드/인프라', sort_order: 3 },
  ],
  getSkills: async () => [
    { id: 1, name: 'Python', category_name: '프로그래밍 언어' },
    { id: 2, name: 'JavaScript', category_name: '프로그래밍 언어' },
    { id: 3, name: 'React', category_name: '프레임워크/라이브러리' },
    { id: 4, name: 'AWS', category_name: '클라우드/인프라' },
  ],
  getEmployeeSkills: async () => [
    { id: 1, skill_id: 1, skill_name: 'Python', category_name: '프로그래밍 언어', proficiency: 5, note: '10년 경력' },
    { id: 2, skill_id: 2, skill_name: 'React', category_name: '프레임워크', proficiency: 4, note: '3년 경력' },
    { id: 3, skill_id: 3, skill_name: 'AWS', category_name: '클라우드/인프라', proficiency: 3, note: '1년 경력' },
    { id: 4, skill_id: 4, skill_name: 'SQL', category_name: '데이터베이스', proficiency: 4, note: '실무 활용' },
  ],
  setEmployeeSkill: async () => ({ message: '데모 모드' }),
  bulkSetEmployeeSkills: async () => ({ updated: 0 }),
  removeEmployeeSkill: async () => ({ removed: true }),
  getSkillMatrix: async () => ({ teams: [], skills: [] }),
  getSkillGaps: async () => ({ total_employees: 30, all_skills: [], skill_gaps: [], skill_strengths: [] }),
  getSkillSummary: async () => ({ total_skills: 30, total_employees: 30, employees_with_skills: 0, coverage_pct: 0, by_category: [], top_skills: [] }),

  // ========== Employee Notes & Tags ==========
  getTagTypes: async () => ({
    key_talent: '핵심 인재', retention_target: '리텐션 대상', high_potential: '고성과자 (High Potential)',
    watch_list: '관찰 대상', succession_candidate: '후계 후보', flight_risk: '이탈 위험',
  }),
  getDisciplinaryTypes: async () => ({
    warning: '경고', reprimand: '문책', suspension: '정직',
    commendation: '표창', award: '포상', bonus: '성과급',
  }),
  getEmployeeNotesSummary: async (id: string) => ({ employee_id: id, tags: [], disciplinary_records: [], hr_comments: [], ai_analysis_text: '' }),
  addEmployeeTag: async () => ({ tag_id: 1, message: '데모 모드' }),
  removeEmployeeTag: async () => ({ message: '데모 모드' }),
  addDisciplinaryRecord: async () => ({ record_id: 1, message: '데모 모드' }),
  deleteDisciplinaryRecord: async () => ({ message: '데모 모드' }),
  addHRComment: async () => ({ comment_id: 1, message: '데모 모드' }),
  deleteHRComment: async () => ({ message: '데모 모드' }),

  // MYB-357: Feedback demo functions removed — replaced by unified ticket system

  // ========== User Management ==========
  getUsers: async () => [
    { id: 1, username: 'admin', role: 'admin', display_name: '관리자', employee_id: null, created_at: '2026-01-01T00:00:00' },
    { id: 2, username: 'hr@demo.com', role: 'hr_manager', display_name: '인사담당자', employee_id: 'TS2600001', created_at: '2026-01-15T00:00:00' },
    { id: 3, username: 'manager@demo.com', role: 'org_head', display_name: '팀장', employee_id: 'TS2600002', created_at: '2026-02-01T00:00:00' },
    { id: 4, username: 'user@demo.com', role: 'employee', display_name: '직원', employee_id: 'TS2600003', created_at: '2026-02-01T00:00:00' },
  ],
  createUser: async (data: any) => ({ id: 99, ...data, created_at: new Date().toISOString() }),
  updateUserRole: async (userId: number, role: string) => ({ id: userId, role }),
  deleteUser: async () => ({ message: 'User deleted successfully' }),

  // ========== Promotion Management ==========
  getPromotionRules: async () => ({
    rules: [
      { id: 1, from_rank_id: 1, to_rank_id: 2, from_rank_name: '사원', to_rank_name: '대리', min_tenure_years: 3, min_eval_grade: 'B', min_eval_count: 1, required_training_ids: [] },
      { id: 2, from_rank_id: 2, to_rank_id: 3, from_rank_name: '대리', to_rank_name: '과장', min_tenure_years: 4, min_eval_grade: 'B', min_eval_count: 1, required_training_ids: [] },
      { id: 3, from_rank_id: 3, to_rank_id: 4, from_rank_name: '과장', to_rank_name: '차장', min_tenure_years: 4, min_eval_grade: 'B', min_eval_count: 1, required_training_ids: [] },
    ],
    total: 3,
  }),
  createPromotionRule: async (data: any) => ({ id: 99, ...data }),
  updatePromotionRule: async (ruleId: number, data: any) => ({ id: ruleId, ...data }),
  extractPromotionCandidates: async () => ({
    extracted: 5, batch_date: new Date().toISOString().slice(0, 10),
    details: [
      { employee_id: 'TS2600001', name: '김철수', from_rank: '대리', to_rank: '과장', tenure_years: 4.5, grade: 'A', score: 82.5 },
      { employee_id: 'TS2600002', name: '이영희', from_rank: '사원', to_rank: '대리', tenure_years: 3.2, grade: 'B', score: 71.0 },
    ],
  }),
  getPromotionCandidates: async () => ({
    candidates: [
      { id: 1, employee_id: 'TS2600001', employee_name: '김철수', employee_team: 'AI Lab', from_rank_name: '대리', to_rank_name: '과장', tenure_years: 4.5, latest_eval_grade: 'A', eligibility_score: 82.5, status: 'eligible', batch_date: '2026-02-10' },
      { id: 2, employee_id: 'TS2600002', employee_name: '이영희', employee_team: 'Product', from_rank_name: '사원', to_rank_name: '대리', tenure_years: 3.2, latest_eval_grade: 'B', eligibility_score: 71.0, status: 'eligible', batch_date: '2026-02-10' },
    ],
    total: 2,
  }),
  updatePromotionCandidate: async (id: number, status: string) => ({ id, status }),
  executePromotion: async (id: number) => ({ id, status: 'promoted' }),
  getPromotionStatistics: async () => ({
    status_counts: { eligible: 5, nominated: 2, approved: 1, promoted: 3 },
    by_rank: [
      { from_rank: '사원', to_rank: '대리', count: 3, avg_score: 72.0 },
      { from_rank: '대리', to_rank: '과장', count: 2, avg_score: 80.5 },
    ],
    by_team: [{ team: 'AI Lab', count: 2 }, { team: 'Product', count: 3 }],
    promotion_rate: 27.3, total_candidates: 11,
    eligible: 5, nominated: 2, approved: 1, promoted: 3,
  }),

  // ========== Payroll Records & Pay Slips ==========
  getPayrollRecords: async () => ({
    records: [
      { id: 1, employee_id: 'TS2600001', employee_name: '김철수', employee_team: 'AI Lab', rank_name: '과장', base_salary: 4000000, position_allowance: 500000, meal_allowance: 200000, transport_allowance: 100000, overtime_pay: 300000, bonus: 0, other_allowance: 0, gross_pay: 5100000, national_pension: 220500, health_insurance: 173723, long_term_care: 22497, employment_insurance: 44100, income_tax: 234000, local_income_tax: 23400, other_deduction: 0, total_deduction: 718220, net_pay: 4381780 },
      { id: 2, employee_id: 'TS2600002', employee_name: '이영희', employee_team: 'Product', rank_name: '대리', base_salary: 3200000, position_allowance: 300000, meal_allowance: 200000, transport_allowance: 100000, overtime_pay: 150000, bonus: 0, other_allowance: 0, gross_pay: 3950000, national_pension: 168750, health_insurance: 132938, long_term_care: 17215, employment_insurance: 33750, income_tax: 142500, local_income_tax: 14250, other_deduction: 0, total_deduction: 509403, net_pay: 3440597 },
    ],
    total: 2,
  }),
  createPayrollRecord: async (data: any) => ({ id: 99, ...data, gross_pay: data.base_salary + (data.position_allowance || 0), net_pay: data.base_salary }),
  updatePayrollRecord: async (id: number, data: any) => ({ id, ...data }),
  deletePayrollRecord: async () => ({ status: 'deleted' }),
  getPaySlips: async () => ({ slips: [], total: 0 }),
  getMyPaySlips: async () => ({ slips: [], total: 0 }),
  issuePaySlips: async () => ({ issued: 0 }),
  acknowledgePaySlip: async () => ({ status: 'acknowledged' }),
  getPayrollSummary: async () => ({
    pay_year: 2026, pay_month: null,
    summary: { count: 0, total_gross: 0, total_deduction: 0, total_net: 0, avg_gross: 0, avg_net: 0 },
    by_team: [], slip_status: {}, monthly_trend: [],
  }),

  // ========== IDP ==========
  getIDPPlans: async () => ({ plans: [], total: 0 }),
  getIDPPlan: async () => ({ id: 1, title: '데모 IDP', goals: [], checkins: [] }),
  createIDPPlan: async () => ({ id: 1 }),
  updateIDPPlan: async () => ({ success: true }),
  generateIDP: async () => ({ id: 1, message: 'IDP 생성 완료' }),
  updateIDPGoal: async () => ({ success: true }),
  getIDPStatistics: async () => ({
    year: 2026,
    summary: { total_plans: 0, draft_count: 0, active_count: 0, completed_count: 0, avg_progress: 0 },
    by_team: [], by_goal_type: [],
  }),

  // ========== Labor Cost Analysis ==========
  getLaborCostSummary: async () => ({ headcount: 0, total_gross: 0, total_net: 0, total_deduction: 0, avg_gross: 0, avg_net: 0, total_employees: 0, coverage_rate: 0 }),
  getLaborCostByTeam: async () => ({ teams: [], total_gross: 0 }),
  getLaborCostByRank: async () => ({ ranks: [] }),
  getLaborCostTrend: async () => ({ year: 2026, months: [] }),
  simulateLaborCost: async () => ({ total_current: 0, total_projected: 0, total_delta: 0, delta_rate: 0, details: [] }),

  // ========== Data Retention Policies ==========
  getRetentionPolicies: async () => ({ policies: [
    { id: 1, data_type: 'employee_record', retention_years: 3, description: '인사기록카드', legal_basis: '근로기준법 제42조', is_active: 1 },
    { id: 2, data_type: 'payroll_record', retention_years: 5, description: '임금대장', legal_basis: '근로기준법 제48조', is_active: 1 },
    { id: 3, data_type: 'health_check', retention_years: 5, description: '건강검진 기록', legal_basis: '산업안전보건법', is_active: 1 },
    { id: 4, data_type: 'training_record', retention_years: 3, description: '교육 이수 기록', legal_basis: '산업안전보건법 제29조', is_active: 1 },
    { id: 5, data_type: 'evaluation_record', retention_years: 3, description: '인사평가 기록', legal_basis: '개인정보보호법 제21조', is_active: 1 },
    { id: 6, data_type: 'contract', retention_years: 3, description: '근로계약서', legal_basis: '근로기준법 제17조', is_active: 1 },
  ] }),
  updateRetentionPolicy: async () => ok(),
  getRetentionSummary: async () => ({ total_resigned: 3, expired_count: 0, expiring_soon: 1, destroyed_count: 0, recent_destructions: [] }),
  getExpiredEmployees: async () => ({ employees: [], total: 0 }),
  destroyEmployeeData: async () => ok('파기 완료'),
  getDestructionLog: async () => ({ logs: [], total: 0 }),

  // ========== Grievances ==========
  getGrievances: async () => ({ grievances: [], total: 0 }),
  getGrievanceSummary: async () => ({ total: 0, active: 0, overdue: 0, by_category: [], by_status: [] }),
  createGrievance: async () => ok('접수 완료'),
  updateGrievance: async () => ok(),
  getGrievanceDetail: async () => null,

  // ========== Employment Rules ==========
  getEmploymentRules: async () => ({ rules: [], total: 0 }),
  getEmploymentRulesSummary: async () => ({ total: 0, active: 0, draft: 0, opinion_collection: 0, by_category: [] }),
  createEmploymentRule: async () => ok('등록 완료'),
  getEmploymentRuleDetail: async () => null,
  getEmploymentRuleVersionContent: async () => ({ content: '' }),
  updateEmploymentRuleStatus: async () => ok(),

  // ========== Mentoring ==========
  getMentoringPrograms: async () => ({ programs: [] }),
  getMentoringSummary: async () => ({ active_programs: 0, active_pairs: 0, total_sessions: 0, total_hours: 0 }),
  createMentoringProgram: async () => ok('프로그램 생성 완료'),
  getMentoringProgramDetail: async () => null,
  updateMentoringProgram: async () => ok(),
  createMentoringMatch: async () => ok('매칭 완료'),
  createMentoringSession: async () => ok('세션 기록 완료'),

  // ========== Disciplinary Management ==========
  getDisciplinaryConstants: async () => ({
    violation_types: ['attendance', 'conduct', 'performance', 'security', 'ethics', 'harassment', 'property', 'other'],
    discipline_types: ['warning', 'salary_reduction', 'suspension', 'demotion', 'dismissal'],
    case_statuses: ['reported', 'investigating', 'hearing_scheduled', 'hearing_completed', 'decided', 'notified', 'effective', 'appealed', 'closed'],
  }),
  getDisciplinarySummary: async () => ({ total: 0, active: 0, closed: 0, by_status: [], by_violation_type: [], by_discipline_type: [] }),
  getDisciplinaryCases: async () => ({ cases: [], total: 0 }),
  getDisciplinaryCase: async () => null,
  createDisciplinaryCase: async () => ok('사건 접수 완료'),
  updateDisciplinaryCase: async () => ok(),
  transitionDisciplinaryStatus: async () => ok(),
  scheduleDisciplinaryHearing: async () => ok('소명 일정 등록 완료'),
  completeDisciplinaryHearing: async () => ok(),
  createDisciplinaryDecision: async () => ok('징계 결정 등록 완료'),
  notifyDisciplinaryDecision: async () => ok(),
  appealDisciplinaryDecision: async () => ok(),
  executeDisciplinaryCase: async () => ok(),
  closeDisciplinaryCase: async () => ok(),
  addDisciplinaryComment: async () => ok('코멘트 추가 완료'),

  // ========== Dashboard Customization ==========
  getDashboardWidgets: async () => {
    const saved = localStorage.getItem('demo_dashboard_widgets');
    if (saved) return JSON.parse(saved);
    const defaultData = { widgets: [
      { widget_type: 'stat_cards', is_visible: true, display_order: 0, label: '통계 카드' },
      { widget_type: 'chart_team', is_visible: true, display_order: 1, label: '팀별 인원 분포' },
      { widget_type: 'chart_position', is_visible: true, display_order: 2, label: '직급별 분포' },
      { widget_type: 'chart_age', is_visible: true, display_order: 3, label: '나이 분포' },
      { widget_type: 'chart_region', is_visible: true, display_order: 4, label: '지역별 인력 분포' },
    ]};
    localStorage.setItem('demo_dashboard_widgets', JSON.stringify(defaultData));
    return defaultData;
  },
  toggleDashboardWidget: async (wt: string, vis: boolean) => {
    const saved = localStorage.getItem('demo_dashboard_widgets');
    if (saved) {
      const data = JSON.parse(saved);
      data.widgets = data.widgets.map((w: any) => w.widget_type === wt ? { ...w, is_visible: vis } : w);
      localStorage.setItem('demo_dashboard_widgets', JSON.stringify(data));
    }
    return ok();
  },
  reorderDashboardWidget: async (wt: string, direction: string) => {
    const saved = localStorage.getItem('demo_dashboard_widgets');
    if (!saved) return ok();
    const data = JSON.parse(saved);
    const sorted = [...data.widgets].sort((a: any, b: any) => a.display_order - b.display_order);
    const idx = sorted.findIndex((w: any) => w.widget_type === wt);
    if (idx === -1) return ok();
    const swapIdx = direction === 'up' ? idx - 1 : idx + 1;
    if (swapIdx < 0 || swapIdx >= sorted.length) return ok();
    const tmpOrder = sorted[idx].display_order;
    sorted[idx].display_order = sorted[swapIdx].display_order;
    sorted[swapIdx].display_order = tmpOrder;
    data.widgets = sorted;
    localStorage.setItem('demo_dashboard_widgets', JSON.stringify(data));
    return ok();
  },
  bulkUpdateDashboardWidgets: async () => ok(),
  resetDashboardWidgets: async () => { localStorage.removeItem('demo_dashboard_widgets'); return ok(); },

  // ========== Overtime Extended (BACK-012) ==========
  getOvertimeDashboard: async () => ({ week_start: '2026-02-09', year_month: '2026-02', risk_distribution: { low: 25, medium: 8, high: 3, critical: 1 }, unresolved_violations: {}, total_unresolved: 0, active_special_extensions: 0, month_over_52_employees: 1 }),
  getOvertimeMonthly: async () => ({ year_month: '2026-02', employee_count: 37, avg_total_hours: 168.5, over_52_employees: 1, items: [] }),
  getOvertimeMonthlyTrends: async () => ({ employee_id: '', trends: [] }),
  getOvertimeViolations: async () => ({ total: 0, type_counts: {}, items: [] }),
  resolveOvertimeViolation: async () => ok(),
  getSpecialExtensions: async () => ({ items: [], total: 0 }),
  createSpecialExtension: async () => ok('특별연장 신청 완료'),
  approveSpecialExtension: async () => ok(),
  getLeaveDashboard: async () => ({ year: 2026, employee_count: 37, total_granted: 555, total_used: 120, total_remaining: 435, total_expired: 0, usage_rate: 21.6, promotion_distribution: { none: 30, first_notice: 5, second_notice: 2 }, expiring_30days: { count: 0, days: 0 }, special_leave_stats: [] }),
  expireAnnualLeaves: async () => ({ expired_count: 0, total_expired_days: 0, details: [] }),
  getUnusedAllowance: async () => ({ employee_id: '', year: 2025, granted: 15, used: 10, remaining: 5, expired: 0, unused_days: 5, daily_wage: 150000, allowance: 750000, promotion_status: 'none', is_company_liable: true, legal_note: '사용촉진 미이행 시 미사용 수당 지급 의무' }),
  cancelAnnualLeave: async () => ok('연차 사용 취소 완료'),
  getSpecialLeaveTypes: async () => ({ types: ['bereavement', 'sick', 'compensatory', 'family_care', 'refreshment'] }),
  getSpecialLeaves: async () => ({ items: [], total: 0 }),
  grantSpecialLeave: async () => ok('특별휴가 부여 완료'),
  useSpecialLeave: async () => ok('특별휴가 사용 처리 완료'),

  // ========== Workflow (결재) BACK-059 ==========
  getWorkflowTypes: async () => ({ types: { leave_request: '휴가 신청', overtime_request: '초과근무 신청', transfer_request: '인사이동 요청', promotion_request: '승진 요청', salary_adjustment: '급여 조정', training_request: '교육 신청', general: '일반 결재' } }),
  getWorkflowStatuses: async () => ({ statuses: { draft: '작성중', submitted: '제출됨', in_approval: '결재진행중', approved: '승인', rejected: '반려', cancelled: '취소', withdrawn: '회수' } }),
  getWorkflowDashboard: async () => ({ status_counts: { draft: 2, in_approval: 5, approved: 18, rejected: 3 }, type_counts: { leave_request: 12, overtime_request: 5, training_request: 4, general: 7 }, urgent_pending: 1, total_active: 7, my_pending_count: 3, my_active_requests: 2 }),
  getWorkflowPending: async () => ({ items: [
    { id: 1, workflow_type: 'leave_request', title: '연차 휴가 신청 (3일)', urgency: 'normal', status: 'in_approval', requester_id: 'TS2600003', requester_name: '이영희', submitted_at: '2026-02-10T09:00:00', step_order: 1, approval_id: 1 },
    { id: 2, workflow_type: 'overtime_request', title: '초과근무 신청 (2/15)', urgency: 'urgent', status: 'in_approval', requester_id: 'TS2600005', requester_name: '박민수', submitted_at: '2026-02-10T10:30:00', step_order: 1, approval_id: 2 },
    { id: 3, workflow_type: 'training_request', title: 'AWS 교육 수강 신청', urgency: 'normal', status: 'in_approval', requester_id: 'TS2600007', requester_name: '최지우', submitted_at: '2026-02-09T14:00:00', step_order: 1, approval_id: 3 },
  ], total: 3 }),
  getWorkflowMyRequests: async () => ({ items: [
    { id: 10, workflow_type: 'leave_request', title: '연차 1일 사용', status: 'approved', urgency: 'normal', created_at: '2026-02-08T09:00:00', completed_at: '2026-02-08T11:00:00' },
    { id: 11, workflow_type: 'general', title: '출장 보고서 제출', status: 'in_approval', urgency: 'normal', created_at: '2026-02-10T08:00:00' },
  ], total: 2 }),
  getWorkflowInstances: async () => ({ items: [], total: 0 }),
  createWorkflowInstance: async () => ({ id: 99, status: 'draft' }),
  getWorkflowInstance: async (id: number) => ({ id, workflow_type: 'leave_request', title: '연차 휴가 신청', status: 'in_approval', requester_id: 'TS2600003', requester_name: '이영희', urgency: 'normal', content_json: '{}', submitted_at: '2026-02-10T09:00:00', created_at: '2026-02-10T08:30:00', approvals: [{ id: 1, step_order: 1, approver_id: 'TS2600001', approver_name: '김팀장', status: 'approved', comment: '승인합니다', acted_at: '2026-02-10T10:00:00' }, { id: 2, step_order: 2, approver_id: 'TS2600002', approver_name: '박승우', status: 'pending' }], history: [{ action: 'created', actor_name: '이영희', created_at: '2026-02-10T08:30:00' }, { action: 'submitted', actor_name: '이영희', created_at: '2026-02-10T09:00:00' }] }),
  submitWorkflow: async () => ({ ok: true, status: 'in_approval' }),
  approveWorkflow: async () => ({ ok: true, remaining_steps: 0 }),
  rejectWorkflow: async () => ({ ok: true, status: 'rejected' }),
  delegateWorkflow: async () => ok(),
  withdrawWorkflow: async () => ({ ok: true, status: 'withdrawn' }),
  cancelWorkflow: async () => ok(),
  addWorkflowStep: async () => ({ ok: true, approval_id: 99 }),
  removeWorkflowStep: async () => ok(),
  getWorkflowTemplates: async () => ({ items: [
    { id: 1, name: '휴가 신청 (팀장 승인)', workflow_type: 'leave_request', description: '팀장 1단계 승인', steps_json: '[{"step":1,"role":"org_head","level":"direct"}]', is_active: true },
    { id: 2, name: '초과근무 (팀장→인사)', workflow_type: 'overtime_request', description: '2단계 결재', steps_json: '[{"step":1,"role":"org_head","level":"direct"},{"step":2,"role":"hr_manager","level":"any"}]', is_active: true },
    { id: 3, name: '인사이동 (3단계)', workflow_type: 'transfer_request', description: '팀장→본부장→인사', steps_json: '[{"step":1,"role":"org_head","level":"direct"},{"step":2,"role":"org_head","level":"parent"},{"step":3,"role":"hr_manager","level":"any"}]', is_active: true },
  ], total: 3 }),
  getWorkflowTemplate: async (id: number) => ({ id, name: '휴가 신청', workflow_type: 'leave_request', description: '팀장 1단계', steps_json: '[{"step":1,"role":"org_head","level":"direct"}]', is_active: true }),
  createWorkflowTemplate: async () => ({ id: 99, message: '템플릿 생성 완료' }),
  updateWorkflowTemplate: async () => ok(),
  deleteWorkflowTemplate: async () => ({ success: true, message: '템플릿이 삭제되었습니다' }),
  getApprovalCatalog: async () => ({ categories: [
    { category: 'attendance', label: '근태', templates: [
      { id: 1, name: '연차 신청 (팀장 1단계)', workflow_type: 'leave_request', description: '팀장 승인', steps_json: '[{"step_order":1,"approver_role":"팀장"}]', catalog_code: 'ATT-001', category: 'attendance', is_system: true, is_active: true, exempt_rank_level: null },
    ]},
    { category: 'personnel', label: '인사', templates: [
      { id: 7, name: '인사이동 (3단계)', workflow_type: 'transfer_request', description: '팀장→본부장→인사', steps_json: '[{"step_order":1,"approver_role":"팀장"},{"step_order":2,"approver_role":"본부장"},{"step_order":3,"approver_role":"인사팀장"}]', catalog_code: 'PER-001', category: 'personnel', is_system: true, is_active: true, exempt_rank_level: 6 },
    ]},
  ] }),
  getEligibleApprovers: async () => ({ items: [
    { employee_id: 'TS2600003', name: '김영호', rank_name: '부장', rank_level: 4, title_name: '팀장', title_level: 3, title_code: 'P03', org_unit_name: '개발팀' },
    { employee_id: 'TS2600007', name: '이승현', rank_name: '이사', rank_level: 6, title_name: '본부장', title_level: 5, title_code: 'P05', org_unit_name: '기술본부' },
  ] }),
  checkWorkflowExempt: async () => ({ exempt: false }),
  replaceWorkflowApprover: async () => ({ ok: true, old_approver: '김영호', new_approver: '이승현' }),
  getWorkflowBadge: async () => ({ pending_approvals: 3, completed_results: 1, urgent: 1, total_badge: 4 }),
  getRecentWorkflows: async () => ({ workflows: [] }),

  // ========== Personnel Orders (BACK-060) ==========
  getPersonnelOrderTypes: async () => ({ transfer: '전보', promotion: '승진', rank_change: '직급 변경', title_change: '직책 변경', secondment: '파견', reinstatement: '복직', concurrent: '겸직', general: '일반 발령' }),
  getPersonnelOrderStatuses: async () => ({ draft: '초안', submitted: '상신', approved: '승인', rejected: '반려', executed: '시행', cancelled: '취소' }),
  getPersonnelOrderDashboard: async () => ({ status_counts: { draft: 1, submitted: 2, approved: 1, executed: 5 }, type_counts: { transfer: 3, promotion: 2 }, recent_orders: [], my_pending: 1, total: 9 }),
  getPersonnelOrdersPending: async () => [
    { id: 1, employee_id: 'TS2600005', employee_name: '정승민', order_type: 'promotion', current_value: '대리', new_value: '과장', effective_date: '2026-03-01', status: 'pending', created_at: '2026-02-10' },
  ],
  getPersonnelOrders: async () => ({ orders: [], total: 0 }),
  createPersonnelOrder: async () => ({ id: 1, order_number: '2026-0001', status: 'draft' }),
  getPersonnelOrder: async () => ({ id: 1, order_number: '2026-0001', order_type: 'transfer', title: '데모 발령', status: 'draft', items: [], history: [] }),
  updatePersonnelOrder: async () => ok(),
  addPersonnelOrderItem: async () => ({ id: 1, message: '추가 완료' }),
  removePersonnelOrderItem: async () => ok(),
  submitPersonnelOrder: async () => ok(),
  approvePersonnelOrder: async () => ok(),
  rejectPersonnelOrder: async () => ok(),
  cancelPersonnelOrder: async () => ok(),
  revertPersonnelOrder: async () => ok(),
  executePersonnelOrder: async () => ok(),
  getEmployeeOrderHistory: async () => [
    { id: 1, order_type: 'team_change', previous_value: '영업팀', new_value: '경영지원팀', effective_date: '2025-07-01', status: 'completed', approved_by: '박승우' },
    { id: 2, order_type: 'promotion', previous_value: '사원', new_value: '대리', effective_date: '2025-01-01', status: 'completed', approved_by: '박승우' },
  ],

  // ========== Favorites ==========
  getFavorites: async () => ({ favorites: [] }),
  addFavorite: async () => ({ success: true }),
  removeFavorite: async () => ({ success: true }),
  removeFavoriteById: async () => ({ success: true }),
  checkFavorite: async () => ({ is_favorite: false }),

  // ========== Retention Risk ==========
  getRetentionDashboard: async () => ({
    total_employees: 29, high_risk: 3, medium_risk: 8, low_risk: 18,
    high_risk_employees: [
      { employee_id: 'demo-1', name: '홍길동', team: '개발1팀', risk_score: 65, risk_level: 'high', tenure_years: 1.5, triggered_risks: [{ factor: 'tenure_short', weight: 15, desc: '근속 2년 미만' }], recommended_programs: [{ id: 'onboarding_plus', name: '온보딩 강화', description: '신입 정착 지원' }] },
    ],
    team_distribution: [
      { team: '개발1팀', high: 1, medium: 2, low: 3, total: 6 },
      { team: '개발2팀', high: 1, medium: 1, low: 4, total: 6 },
    ],
    risk_factors_summary: [
      { factor: 'no_promotion', count: 8, percentage: 27.6, weight: 20, desc: '최근 3년 내 승진 없음' },
    ],
  }),
  getEmployeeRetentionRisk: async () => ({
    employee_id: 'demo-1', name: '홍길동', team: '개발1팀', tenure_years: 1.5,
    risk_score: 35, risk_level: 'medium',
    triggered_risks: [{ factor: 'tenure_short', weight: 15, desc: '근속 2년 미만' }],
    recommended_programs: [{ id: 'onboarding_plus', name: '온보딩 강화', description: '신입 정착 지원' }],
  }),

  // ========== Group Transfers & Cross-Consent ==========
  getTransfers: async (params?: any) => {
    const all = [
      { id: 1, employee_id: 'TS2600005', employee_name: '이준호', from_company_id: 1, from_company_name: '티사이언티픽', to_company_id: 2, to_company_name: 'TS Digital', status: 'completed', reason: 'DX 추진 인력 지원', effective_date: '2026-01-02', requested_at: '2025-11-15', executed_at: '2026-01-02' },
      { id: 2, employee_id: 'TS2600012', employee_name: '한미영', from_company_id: 1, from_company_name: '티사이언티픽', to_company_id: 3, to_company_name: 'TS Bio', status: 'consent_requested', reason: '바이오 연구 합류', effective_date: '2026-03-01', requested_at: '2026-02-01', executed_at: null },
      { id: 3, employee_id: 'TS2600019', employee_name: '정서윤', from_company_id: 2, from_company_name: 'TS Digital', to_company_id: 1, to_company_name: '티사이언티픽', status: 'approved', reason: 'IT 인프라 구축', effective_date: '2026-03-15', requested_at: '2026-02-05', executed_at: null },
    ];
    let filtered = all;
    if (params?.employee_id) filtered = filtered.filter(t => t.employee_id === params.employee_id);
    if (params?.status) filtered = filtered.filter(t => t.status === params.status);
    return { transfers: filtered, total: filtered.length };
  },
  getTransferDetail: async (transferId?: number) => ({
    id: transferId || 1, employee_id: 'TS2600005', employee_name: '이준호',
    from_company_id: 1, from_company: '티사이언티픽', from_rank: '대리', from_team: 'IT개발팀',
    to_company_id: 2, to_company: 'TS Digital', to_rank: 'Senior', to_team: 'Platform팀',
    status: 'completed', reason: 'DX 추진 인력 지원',
    requested_at: '2025-11-15', consented_at: '2025-11-20', executed_at: '2026-01-02', grace_period_end: '2026-01-09',
    snapshot: { rank: '대리', salary: 46000000, org_unit: 'IT개발팀', evaluations: 2 },
  }),
  createTransfer: async () => ok('이관 요청 생성 (데모)'),
  consentTransfer: async () => ok('이관 동의 처리 (데모)'),
  executeTransfer: async () => ok('이관 실행 (데모)'),
  rollbackTransfer: async () => ok('이관 롤백 (데모)'),
  getTransferSnapshot: async () => ({ snapshot: { rank: '대리', salary: 46000000, org_unit: 'IT개발팀' } }),
  approveTransferFromHr: async () => ok('전출 HR 승인 (데모)'),
  approveTransferToHr: async () => ok('전입 HR 승인 (데모)'),
  approveTransferGroupHr: async () => ok('그룹 HR 승인 (데모)'),
  createDelegation: async () => ({ id: 1 }),
  getDelegations: async () => ({ delegations: [] }),
  revokeDelegation: async () => ({ success: true }),
  getCrossConsentSummary: async () => ({
    total_consents: 87, active: 72, pending: 10, refused: 3, withdrawn: 2,
    by_purpose: { evaluation: 29, analysis: 25, talent_pool: 18, benchmark: 15 },
    consent_rate: 82.8,
  }),
  getCrossConsentByEmployee: async (employeeId?: string) => ({
    employee_id: employeeId || 'TS2600001',
    consents: [
      { id: 1, purpose: 'evaluation', purpose_label: '그룹사 간 평가 데이터 공유', status: 'active', from_company: '티사이언티픽', to_company: 'TSCORP 그룹', consented_at: '2026-01-10', expires_at: '2027-01-10' },
      { id: 2, purpose: 'analysis', purpose_label: '인력 분석 데이터 활용', status: 'active', from_company: '티사이언티픽', to_company: 'TSCORP 그룹', consented_at: '2026-01-10', expires_at: '2027-01-10' },
      { id: 3, purpose: 'talent_pool', purpose_label: '그룹 인재풀 등록', status: 'pending', from_company: '티사이언티픽', to_company: 'TS Digital', consented_at: null, expires_at: null },
    ],
  }),
  requestCrossConsent: async () => ok('동의 요청 생성 (데모)'),
  bulkRequestCrossConsent: async () => ok('일괄 동의 요청 (데모)'),
  respondCrossConsent: async () => ok('동의 응답 처리 (데모)'),
  withdrawCrossConsent: async () => ok('동의 철회 (데모)'),
  getNonConsentedList: async () => ({
    employees: [
      { employee_id: 'TS2600007', name: '강지훈', team: 'IT개발팀', missing_purposes: ['talent_pool', 'benchmark'] },
      { employee_id: 'TS2600018', name: '황도윤', team: '생산팀', missing_purposes: ['evaluation', 'analysis', 'talent_pool', 'benchmark'] },
    ],
    total: 2,
  }),
  getConsentPurposes: async () => ({
    purposes: [
      { code: 'evaluation', name: '그룹사 간 평가 데이터 공유', description: '성과 평가 결과를 그룹사 간 비교·분석 목적으로 공유', legal_basis: '개인정보보호법 제17조 제1항 (동의)' },
      { code: 'analysis', name: '인력 분석 데이터 활용', description: '인력 현황, 이직 예측, 조직 효율성 분석에 활용', legal_basis: '개인정보보호법 제17조 제1항 (동의)' },
      { code: 'talent_pool', name: '그룹 인재풀 등록', description: '그룹 차원 핵심 인재풀에 등록하여 순환 배치 후보로 관리', legal_basis: '개인정보보호법 제17조 제1항 (동의)' },
      { code: 'benchmark', name: '그룹 벤치마킹', description: '급여, 역량, 성과 지표의 그룹사 간 벤치마킹에 활용', legal_basis: '개인정보보호법 제17조 제1항 (동의)' },
    ],
  }),

  // ========== Data Subject Rights (GDPR) ==========
  createDataSubjectRequest: async () => ok('정보주체 청구 접수 (데모)'),
  getDataSubjectRequests: async () => ({
    requests: [
      { id: 1, employee_id: 'TS2600018', employee_name: '황도윤', request_type: 'access', request_type_label: '열람 청구', status: 'completed', requested_at: '2026-01-20', completed_at: '2026-01-25', notes: '인사기록카드 사본 제공 완료' },
      { id: 2, employee_id: 'TS2600023', employee_name: '임수진', request_type: 'correction', request_type_label: '정정 청구', status: 'in_review', requested_at: '2026-02-10', completed_at: null, notes: '경력사항 정정 요청' },
    ],
    total: 2,
  }),
  reviewDataSubjectRequest: async () => ok('청구 심사 처리 (데모)'),
  getDataSubjectSummary: async () => ({
    total: 5, pending: 1, in_review: 1, completed: 3,
    by_type: { access: 2, correction: 2, deletion: 0, suspension: 1 },
    avg_resolution_days: 4.2,
  }),
  getDataSubjectTypes: async () => ({
    types: [
      { code: 'access', name: '열람 청구', description: '본인 개인정보 열람', legal_deadline_days: 10 },
      { code: 'correction', name: '정정 청구', description: '본인 개인정보 정정/삭제', legal_deadline_days: 10 },
      { code: 'deletion', name: '삭제 청구', description: '개인정보 삭제 요청', legal_deadline_days: 10 },
      { code: 'suspension', name: '처리정지 청구', description: '개인정보 처리 정지', legal_deadline_days: 10 },
    ],
  }),

  // ========== Reports ==========
  getReportTypes: async () => [
    { id: 'employee_roster', name: '직원 명부', description: '전체 직원 목록', formats: ['excel', 'csv'] },
    { id: 'team_headcount', name: '팀별 인원 현황', description: '팀별 인원수', formats: ['excel', 'csv'] },
  ],
  downloadReport: async () => new Blob(['데모 모드에서는 리포트를 다운로드할 수 없습니다.'], { type: 'text/plain' }),
  previewReport: async () => ({ report_id: 'demo', headers: [], keys: [], total: 0, preview_count: 0, rows: [] }),
  getReportHistory: async () => ({ history: [], total: 0 }),
  getReportScheduleTypes: async () => ({ report_types: ['employee_roster', 'team_headcount', 'evaluation_summary'], frequencies: ['daily', 'weekly', 'monthly'] }),
  createReportSchedule: async (_data: any) => ({ id: 1 }),
  getReportSchedules: async () => [
    { id: 1, report_type: 'team_headcount', frequency: 'monthly', next_run: '2026-03-01', enabled: true, created_by: 'user1@example.com' },
  ],
  getReportSchedule: async (id: number) => ({ id, history: [] }),
  updateReportSchedule: async (_id: number, _data: any) => ({ success: true }),
  deleteReportSchedule: async (_id: number) => ({ success: true }),

  // ========== Legal Documents ==========
  getDocumentTypes: async () => ({
    documents: [
      { id: 'annual_leave_notice', name: '연차 사용촉진 통보서', description: '근로기준법 제61조', requires: ['employee_id', 'year'] },
      { id: 'evaluation_notice', name: '평가 결과 통지서', description: '인사평가 결과 서면 통지', requires: ['employee_id'] },
      { id: 'personnel_order', name: '인사발령장', description: '인사발령 공식 문서', requires: ['employee_id', 'change_type'] },
    ],
  }),
  downloadAnnualLeaveNotice: async () => new Blob(['데모 모드에서는 문서를 생성할 수 없습니다.'], { type: 'text/plain' }),
  downloadEvaluationNotice: async () => new Blob(['데모 모드에서는 문서를 생성할 수 없습니다.'], { type: 'text/plain' }),
  downloadPersonnelOrder: async () => new Blob(['데모 모드에서는 문서를 생성할 수 없습니다.'], { type: 'text/plain' }),

  // ========== Onboarding Tutorial (BACK-227) ==========
  getOnboardingSteps: async (role?: string) => {
    const DEMO_STEPS: Record<string, any[]> = {
      admin: [
        { id: 'welcome', title: '인력 관리 시스템에 오신 것을 환영합니다', description: 'AI 기반 인력 분석 플랫폼의 주요 기능을 소개합니다.', detail_description: '이 시스템은 조직 관리, 성과 평가, 보상, 컴플라이언스, AI 분석까지 인사 업무 전반을 통합 관리합니다.\n관리자로서 시스템 전체를 설정하고 운영할 수 있습니다.', icon: 'sparkles' },
        { id: 'system_settings', title: '시스템 설정', description: '사용자 관리, 회사 정보, 데이터 가져오기를 설정합니다.', detail_description: '시스템 설정에서는 사용자 계정 관리, 법인/자회사 등록, 권한 위임, 데이터 일괄 가져오기 등 관리자 전용 기능을 수행할 수 있습니다.', icon: 'cog', target_menu: 'system_settings', cta_text: '시스템 설정 바로가기', cta_action: 'navigate:system_settings' },
        { id: 'org_mgmt', title: '조직 & 인력 관리', description: '조직도, 직원 목록, 인사 발령을 관리합니다.', detail_description: '조직도에서 부서 구조를 확인하고, 직원 상세 정보를 조회할 수 있습니다.\n인사 발령을 생성하고 시행하면 조직 변경이 자동 반영됩니다.', icon: 'building', target_menu: 'org_mgmt', cta_text: '조직도 보기', cta_action: 'navigate:org_mgmt' },
        { id: 'eval_mgmt', title: '성과 평가 설정', description: '평가 기간, 평가 항목, 등급 체계를 설정합니다.', detail_description: '성과 관리에서는 평가 기간을 생성하고, 평가자를 자동/수동 배정할 수 있습니다.\n등급 보정과 강제 배분도 관리합니다.', icon: 'chart', target_menu: 'eval_mgmt', cta_text: '평가 기간 관리', cta_action: 'navigate:eval_mgmt' },
        { id: 'complete', title: '준비 완료!', description: '이제 인력 관리 시스템의 모든 기능을 사용할 수 있습니다.', detail_description: '관리자로서 시스템 전체를 운영할 준비가 되었습니다.', icon: 'rocket' },
      ],
      employee: [
        { id: 'welcome', title: '인력 관리 시스템에 오신 것을 환영합니다', description: '직원을 위한 셀프서비스 기능을 안내합니다.', detail_description: '이 시스템에서 내 인사 정보 확인, 결재 요청, 자기 평가 등을 직접 처리할 수 있습니다.', icon: 'sparkles' },
        { id: 'mypage', title: '마이페이지', description: '내 인사 정보, 연차, 평가 결과를 확인합니다.', detail_description: '마이페이지에서 내 기본 정보, 경력, 학력, 자격증을 확인합니다.\n연차 잔여일, 교육 이수 현황, 최근 평가 등급도 볼 수 있습니다.', icon: 'user', target_menu: 'mypage', cta_text: '마이페이지 보기', cta_action: 'navigate:mypage' },
        { id: 'workflow', title: '결재함', description: '휴가, 초과근무 등 결재를 요청합니다.', detail_description: '결재함에서 휴가 신청, 초과근무 신청 등을 결재 요청할 수 있습니다.', icon: 'document_check', target_menu: 'workflow', cta_text: '결재함 보기', cta_action: 'navigate:workflow' },
        { id: 'complete', title: '준비 완료!', description: '이제 인력 관리 시스템을 사용할 수 있습니다.', detail_description: '마이페이지에서 내 정보를, 결재함에서 신청을 처리하세요.', icon: 'rocket' },
      ],
    };
    const r = role || 'employee';
    const steps = DEMO_STEPS[r] || DEMO_STEPS['employee'];
    return { steps, role: r, total: steps.length };
  },
  getOnboardingStepDetail: async (stepId: string, _role?: string) => ({ id: stepId, title: '', description: '', icon: 'sparkles' }),
  getOnboardingStatus: async () => {
    const done = localStorage.getItem('onboarding_completed') === '1';
    return { user_id: 'demo', completed_steps: [], is_completed: done ? 1 : 0, skipped: done ? 1 : 0 };
  },
  completeOnboardingStep: async (stepId: string, _role?: string) => {
    localStorage.setItem('onboarding_completed', '1');
    return { completed_steps: [stepId], is_completed: 1 };
  },
  skipOnboarding: async () => {
    localStorage.setItem('onboarding_completed', '1');
    return { is_completed: 1, skipped: 1 };
  },
  resetOnboarding: async () => ({ completed_steps: [], is_completed: 0, skipped: 0 }),

  // ========== Harassment Reporting (BACK-081) ==========
  createHarassmentReport: async (_data: any) => ({ id: 1, report_number: 'HR-202602-001', status: 'received' }),
  getHarassmentReports: async () => ({ reports: [], total: 0 }),
  getHarassmentReport: async (id: number) => ({ id, status: 'received' }),
  getHarassmentStats: async () => ({ total: 0, by_status: {}, by_type: {}, type_labels: {}, status_labels: {} }),
  getHarassmentTypes: async () => [
    { value: 'verbal', label: '언어적 괴롭힘' }, { value: 'physical', label: '신체적 괴롭힘' },
    { value: 'emotional', label: '정서적 괴롭힘' }, { value: 'power_abuse', label: '직권 남용' },
    { value: 'isolation', label: '따돌림/배제' }, { value: 'other', label: '기타' },
  ],
  getMyHarassmentReports: async () => ({ reports: [], total: 0 }),
  updateHarassmentStatus: async (_id: number, _data: any) => ({ success: true }),
  addHarassmentAction: async (_id: number, _data: any) => ({ id: 1 }),

  // ========== Salary Tables & Incentives ==========
  getSalaryTables: async () => [
    { id: 1, rank_name: '사원', base_salary: 35000000, min_salary: 30000000, max_salary: 40000000, annual_increase_rate: 5.0 },
    { id: 2, rank_name: '대리', base_salary: 42000000, min_salary: 38000000, max_salary: 50000000, annual_increase_rate: 4.5 },
    { id: 3, rank_name: '과장', base_salary: 52000000, min_salary: 46000000, max_salary: 60000000, annual_increase_rate: 4.0 },
    { id: 4, rank_name: '차장', base_salary: 62000000, min_salary: 55000000, max_salary: 72000000, annual_increase_rate: 3.5 },
    { id: 5, rank_name: '부장', base_salary: 75000000, min_salary: 65000000, max_salary: 88000000, annual_increase_rate: 3.0 },
  ],
  updateSalaryTable: async (_id: number, _data: any) => ({ success: true }),
  getSalaryHistory: async (employeeId: string) => [
    { id: 1, employee_id: employeeId, effective_date: '2026-01-01', base_salary: 48000000, allowances: 3600000, total_salary: 51600000, change_reason: '연봉 인상', change_rate: 5.0, approved_by: '박승우' },
    { id: 2, employee_id: employeeId, effective_date: '2025-01-01', base_salary: 45700000, allowances: 3600000, total_salary: 49300000, change_reason: '승진 인상', change_rate: 8.0, approved_by: '박승우' },
    { id: 3, employee_id: employeeId, effective_date: '2024-01-01', base_salary: 42300000, allowances: 3000000, total_salary: 45300000, change_reason: '정기 인상', change_rate: 4.0, approved_by: '박승우' },
  ],
  addSalaryRecord: async (data: any) => ({ id: 1, total_salary: data.base_salary + (data.allowances || 0) }),
  simulateSalaryIncrease: async (rate: number) => {
    const totalCurrent = 1764000000;
    const totalIncrease = Math.round(totalCurrent * (rate / 100));
    return { employees: [], summary: { total_employees: 37, total_current: totalCurrent, total_new: totalCurrent + totalIncrease, total_increase: totalIncrease, avg_increase_rate: rate } };
  },
  getSalaryStats: async () => ({ by_rank: [
    { rank_name: '사원', base_salary: 36000000, min_salary: 32000000, max_salary: 40000000, employee_count: 8 },
    { rank_name: '주임', base_salary: 42000000, min_salary: 38000000, max_salary: 46000000, employee_count: 6 },
    { rank_name: '대리', base_salary: 50000000, min_salary: 45000000, max_salary: 55000000, employee_count: 9 },
    { rank_name: '과장', base_salary: 60000000, min_salary: 54000000, max_salary: 66000000, employee_count: 7 },
    { rank_name: '차장', base_salary: 72000000, min_salary: 65000000, max_salary: 80000000, employee_count: 4 },
    { rank_name: '부장', base_salary: 85000000, min_salary: 78000000, max_salary: 95000000, employee_count: 3 },
  ] }),
  createIncentivePool: async (_data: any) => ({ id: 1 }),
  getIncentivePools: async () => [
    { id: 1, name: '2026 상반기 성과 인센티브', year: 2026, total_amount: 500000000, distribution_method: 'grade_based', status: 'active', created_by: 'user1@example.com' },
  ],
  getIncentivePool: async (id: number) => ({ id, distributions: [], company_allocations: [] }),
  simulateIncentive: async (total: number) => ({ total_amount: total, total_employees: 0, distributions: [], by_grade: {}, coefficients: {} }),
  simulateGroupIncentive: async (total: number, _companies: any[]) => ({ total_amount: total, company_count: 0, allocations: [] }),
  saveIncentiveSimulation: async (_poolId: number, _dists: any[]) => ({ saved: 0 }),

  // ========== Notifications & Alerts ==========
  getNotificationPreferences: async () => [
    { type: 'evaluation', email: true, in_app: true },
    { type: 'workflow', email: true, in_app: true },
    { type: 'training', email: false, in_app: true },
  ],
  updateNotificationPreferences: async (_prefs: any[]) => ({ updated: 0 }),
  getNotificationChannels: async () => ({ channels: ['web', 'email', 'teams'], types: [], frequencies: ['realtime', 'daily', 'weekly'] }),
  getNotifications: async () => ({ notifications: [], total: 0, unread: 0 }),
  getUnreadNotificationCount: async () => ({ count: 0 }),
  markNotificationRead: async (_id: number) => ({ success: true }),
  markAllNotificationsRead: async () => ({ marked: 0 }),
  createNotification: async (_data: any) => ({ id: 1 }),
  getAlerts: async () => ({ alerts: [], total: 0, unread_count: 0 }),
  getAlertCount: async () => ({ unread_count: 0 }),
  markAlertsRead: async () => ({ updated: 0 }),
  markAllAlertsRead: async () => ({ updated: 0 }),
  dismissAlert: async () => ({ success: true }),
  generateAlerts: async () => ({ total_new: 0, details: {} }),

  // ========== Grade Distribution & Calibration ==========
  getGradeDistribution: async (_periodId: number) => ({ distribution: [
    { grade: 'S', count: 3, ratio: 10, avg_score: 95 },
    { grade: 'A', count: 6, ratio: 20, avg_score: 85 },
    { grade: 'B', count: 12, ratio: 40, avg_score: 75 },
    { grade: 'C', count: 6, ratio: 20, avg_score: 65 },
    { grade: 'D', count: 3, ratio: 10, avg_score: 55 },
  ], total: 30, standard: { S: 10, A: 20, B: 40, C: 20, D: 10 } }),
  createCalibrationSession: async (_data: any) => ({ id: 1 }),
  getCalibrationSessions: async () => [
    { id: 1, period_id: 1, name: '2025 하반기 등급 보정', status: 'completed', conducted_by: '박승우', conducted_at: '2026-01-25', adjustments_count: 3 },
  ],
  getCalibrationSession: async (id: number) => ({ id, adjustments: [] }),
  saveCalibrationAdjustments: async (_sessionId: number, _adjs: any[]) => ({ saved: 0 }),
  applyCalibrationSession: async (_sessionId: number) => ({ applied: 0 }),
  getCalibrationComparison: async (_periodId: number) => ({ companies: [], standard_distribution: { S: 10, A: 20, B: 40, C: 20, D: 10 } }),

  // ========== Misc Group/Multi-company ==========
  getDispatchExpiryAlerts: async () => ({ expiring_30d: [], expiring_7d: [], over_2years: [] }),
  getGroupDashboard: async () => ({ companies: [
    { id: 1, code: 'TSC', name: '티사이언티픽', industry: 'IT', employee_count: 37, avg_tenure_years: 3.2, turnover_rate: 5.4, avg_eval_score: 72.5, rank_distribution: [] },
    { id: 2, code: 'TSI', name: '티사이언스', industry: '바이오', employee_count: 25, avg_tenure_years: 2.8, turnover_rate: 8.0, avg_eval_score: 70.0, rank_distribution: [] },
  ], total_companies: 2 }),
  getGroupSummary: async () => ({ total_employees: 62, total_companies: 2, monthly_hires: 3, monthly_leaves: 1, total_transfers: 0 }),
  previewImport: async () => ({ columns: ['이름','팀','직급'], total_rows: 0, preview_rows: [], parsed_count: 0 }),
  executeImport: async () => ({ created: 0, skipped: 0, errors: [], total_rows: 0 }),
  importEmployeesPreview: async () => ({ columns: ['이름','팀','직급'], total_rows: 0, preview_rows: [], parsed_count: 0, company_id: 1 }),
  importEmployeesExecute: async () => ({ created: 0, skipped: 0, errors: [], total_rows: 0 }),
  requestGroupMembership: async () => ({ id: 1, status: 'requested' }),
  approveGroupMembership: async () => ({ id: 1, status: 'active' }),
  requestGroupLeave: async () => ({ id: 1, status: 'leave_grace', grace_period_days: 30 }),
  confirmGroupLeave: async () => ({ id: 1, status: 'left' }),
  getMembershipHistory: async () => ({ history: [], total: 0 }),
  checkTenantAccess: async () => ({ has_access: true, user_company_id: 1, target_company_id: 1 }),
  getMyDelegations: async () => ({ delegations: [], total: 0 }),
  getDelegation: async (id: number) => ({ id, delegator_name: 'Admin', delegate_name: 'User', permissions: [], status: 'active' }),
  updateDelegation: async () => ({ success: true }),
  getTransferPermissions: async () => ({ role: 'admin', company_id: 1, transfer_permissions: {} }),
  checkTransferPermission: async () => ({ allowed: true, reason: 'Demo mode' }),
  getTransferApprovalStatus: async (id: number) => ({ id, approval_status: 'pending', approval_steps: [] }),
  executeOutboundTransfer: async () => ({ status: 'completed' }),
  createOrganizationUnit: async () => ({ id: 1, name: 'Demo Unit' }),
  addEmailDomain: async () => ({ status: 'ok' }),
  createTransferRequest: async () => ({ id: 1, status: 'consent_requested' }),
  register: async () => ({ id: 1, username: 'demo@test.com' }),

  // Outbound transfers (BACK-201)
  createOutbound: async () => ({ id: 1, status: 'requested', employee_id: 'TS2600001', from_company_id: 1, to_company_id: 2 }),
  getOutbounds: async () => ({ outbounds: [], total: 0 }),
  getOutboundDetail: async (id: number) => ({ id, status: 'requested', employee_id: 'TS2600001', employee_name: '김철수', from_company_name: '티사이언티픽', to_company_name: '티사이언스', resignation_date: '2026-03-01', rehire_date: '2026-03-15' }),
  approveOutbound: async (id: number) => ({ id, status: 'from_hr_approved' }),
  executeOutbound: async (id: number) => ({ id, status: 'completed', new_employee_id: 'TS2600001_OUT_2' }),
  cancelOutbound: async (id: number) => ({ id, status: 'cancelled' }),
  requestReturn: async (id: number) => ({ id: id + 100, status: 'requested', transfer_type: 'return' }),
  executeReturn: async (id: number) => ({ id, status: 'completed' }),

  // Employee edit requests (BACK-165)
  getEditableFields: async () => [
    { field: 'phone', label: '전화번호' }, { field: 'address', label: '주소' },
    { field: 'emergency_contact', label: '비상연락처' }, { field: 'email', label: '이메일' },
    { field: 'bank_account', label: '계좌번호' }, { field: 'marital_status', label: '결혼 여부' },
  ],
  createEditRequest: async (data: any) => ({ id: 1, ...data, status: 'pending', created_at: Date.now() / 1000 }),
  getMyEditRequests: async () => [
    { id: 1, field: 'address', current_value: '서울 강남구', new_value: '경기 성남시', status: 'pending', requested_at: '2026-02-12' },
  ],
  getEditRequests: async () => ({ requests: [], total: 0 }),
  getEditRequestDetail: async (id: number) => ({ id, status: 'pending' }),
  approveEditRequest: async (id: number) => ({ id, status: 'approved' }),
  rejectEditRequest: async (id: number) => ({ id, status: 'rejected' }),
  cancelEditRequest: async (id: number) => ({ id, status: 'cancelled' }),
  getEditRequestPendingCount: async () => ({ count: 0 }),

  // AI access scope (BACK-163)
  getAIAccessScope: async (unitId: number) => ({ org_unit_id: unitId, ai_access_scope: 'descendants' }),
  setAIAccessScope: async (unitId: number, scope: string) => ({ org_unit_id: unitId, ai_access_scope: scope }),

  // Assignments (BACK-126)
  getEmployeeAssignments: async () => ({ assignments: [], total: 0 }),
  createEmployeeAssignment: async (data: any) => ({ id: 1, ...data, status: 'active' }),
  updateEmployeeAssignment: async (_id: number, data: any) => data,
  getCrossEvalWeights: async (employeeId: string) => ({
    employee_id: employeeId,
    weights: [{ employee_id: employeeId, type: 'primary', weight: 1.0, raw_weight: 1.0, org_unit_name: '주소속' }],
  }),
};
